import {RootState} from "../../types";

export const connectedDevices = (state: RootState) => state.app.dataChannels;